export default "__VITE_ASSET__DFlLr2p8__"